import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface PackageMasterState {
  data: any[] | null;
  currentPage: number | null;
  totalRecords: number | null;
  totalPages: number | null;
  allPackageMasterList: any[]; 
  searchResults: any[] | null;
}

const initialState: PackageMasterState = {
  data: null,
  currentPage: null,
  totalRecords: null,
  totalPages: null,
  allPackageMasterList: [],
  searchResults: null,
};

export const packageMasterSlice = createSlice({
  name: 'packageMaster',
  initialState,
  reducers: {
    // Pagination API
    setAllPackageMaster: (state, action) => {
      state.data = action.payload.data.content;
      state.totalRecords = action.payload.data.totalItems;
      state.totalPages = action.payload.data.totalPages;
      state.currentPage = action.payload.data.number;
    },

    // Search API
    setAllPackageMasterBySearch: (state, action) => {
      state.searchResults = action.payload.data.content;
      state.totalRecords = action.payload.data.totalItems;
      state.totalPages = action.payload.data.totalPages;
      state.currentPage = action.payload.data.number;
    },

    // Get All without pagination
    setAllPackageMasterList: (state, action) => {
      state.allPackageMasterList = action.payload.data;
    },

    reset: (state) => {
      state.data = null;
      state.currentPage = null;
      state.totalRecords = null;
      state.totalPages = null;
      state.allPackageMasterList = [];
    },
  },
});

// Export actions
export const {
  setAllPackageMaster,
  setAllPackageMasterBySearch,
  setAllPackageMasterList,
  reset
} = packageMasterSlice.actions;

//  Export selectors
export const getPackageMasterData = (state: RootState) => state.packageMaster.data; // for pagination
export const getPackageMasterSearchData = (state: RootState) => state.packageMaster.searchResults; // for search
export const getPackageMasterTotalRecords = (state: RootState) => state.packageMaster.totalRecords;
export const getPackageMasterList = (state: RootState) => state.packageMaster.allPackageMasterList;
export const getPackageMasterPage = (state: RootState) => state.packageMaster.currentPage;


//  Export reducer
export default packageMasterSlice.reducer;
